// eslint-disable-next-line banned-modules
'use strict';

import './style.less';
import BaseView from '@/classes/base.view';
import template from './b-train-popup-offers-modal.ejs';

import GlUl from '@/utils/global-utils';
import axios from 'axios';
import $ from 'jquery';
import EmailsCollection from '../../b-ticket/b-ticket-popup-offers/b-emails-collection/collection';
import EmailModel from '../../b-ticket/b-ticket-popup-offers/b-emails-collection/b-email/model';
import EmailsCollectionView from '../../b-ticket/b-ticket-popup-offers/b-emails-collection';

export default BaseView.extend({

	template,

	events: {
		'click .b-offers-train-modal__close': 'closeModal',
		'click .b-offers-train-modal__order': 'orderOffers',
		'click .b-offers-train-modal__submit': 'submitOrder',
		'click .b-offers-train-modal__list-item-remove': 'removeOffer',
		'click .js-copy-to-clipboard': 'copyToClipboard',
	},

	ui: {
		noOffersContainer: '.b-offers-train-modal__no-offers',
		formButtons: '.b-offers-train-modal__form-button',
	},

	offers: [],
	ticketModalOffers: null,

	preinitialize(options) {
		BaseView.prototype.preinitialize.call(this, options);
		this.windowEventListenerList.push({
			name: 'resize',
			callback: GlUl.syncModalWidthPosition.bind(this),
		});
	},

	initialize(options) {
		GlUl.popupOffersViewInitialize.call(this, options);
	},

	render(...args) {
		BaseView.prototype.render.apply(this, args);

		this.showModal();
		this.enableDragSort('.drag-sort-enable');

		if (this.passengers != null) {
			this.$el.find('.b-offers-train-modal__title-person').html(this.passengers.join(', '));
			this.$el.find('.b-offers-train-modal__title-person-count').text(this.passengers.length);
		} else {
			this.$el.find('.b-offers-train-modal__title-person-count').text(this.passengersCount || 1);
		}

		this.model.set('emails', new EmailsCollection([], {
			model: EmailModel,
		}));

		const emailsContainer = this.$('.b-offers-train-modal__emails');
		emailsContainer.append(new EmailsCollectionView({
			autoSuggestEmails: this.model.get('autoSuggestEmails'),
			collection: this.model.get('emails'),
			container: emailsContainer,
			model: this.model,
		}));

		return this;
	},

	setOptions({$ticketContainer, data}) {
		this.$ticketContainer = $ticketContainer;
		this.offers = data;

		return this;
	},

	closeModal() {
		if (this.ticketModalOffers != null) {
			this.ticketModalOffers.hide();
		}
	},

	showModal() {
		this.ticketModalOffers = new Widgets.Popup({
			content: this.$el,
			actions: [],
			classes: 'b-ticket-popup-offers-modal',
			maskClasses: 'b-ticket-popup-offers-modal_mask b-ticket-popup-offers-modal_mask--train',
			overlayFixed: true,
		});

		GlUl.syncModalWidthPosition.call(this);
		this.ticketModalOffers.show();
	},

	checkOffersCount() {
		if (_.isEmpty(this.offers)) {
			this.ui.noOffersContainer.removeClass('dn');
			this.ui.formButtons.addClass('disabled');
		} else {
			this.ui.noOffersContainer.addClass('dn');
			this.ui.formButtons.removeClass('disabled');
		}
	},

	updateOffersOrder() {
		const $offersCards = this.$el.find('.b-offers-train-modal__list .b-offers-train-modal__list-item');
		const orderDataToken = _.map($offersCards, (o) => o.getAttribute('data-token'));
		GlUl.updateOffersOrder.call(this, orderDataToken);
	},

	// DRAG and DROP
	enableDragSort(listClass) {
		const sortableLists = this.$el.find(listClass);
		_.each(sortableLists, (list) => this.enableDragList(list));
	},

	enableDragList(list) {
		_.each(list.children, (item) => this.enableDragItem(item));
	},

	enableDragItem(item) {
		$(item).attr('draggable', true);

		item.ondrag = GlUl.handleDrag.bind(this);
		item.ondragend = this.handleDrop.bind(this);
		item.ondragover = (e) => e.preventDefault();
	},

	handleDrop(e) {
		const $item = $(e.currentTarget);
		$item.removeClass('drag-sort-active');

		this.updateOffersOrder();
	},

	// EVENTS
	removeOffer(e) {
		if (e != null) {
			e.preventDefault();
		}

		const $target = $(e.currentTarget);
		const $container = $target.closest('.b-offers-train-modal__list-item');
		const $commentRow = $container.siblings('.b-offers-train-modal__list-item-comment').first();
		const token = $container.attr('data-token');

		if (this.options.parent != null && _.isFunction(this.options.parent.addOffer)) {
			this.options.parent.addOffer(e, { token }, true);
		}

		$container.remove();
		$commentRow.remove();
		// Change button on the card
		if (token) {
			$(`.btn[data-token="${_.escape(token)}"]`).first().trigger('click');
		}

		this.checkOffersCount();
	},

	submitOrder(e) {
		this.orderOffers(e, _.extend({ sendEmail: true }));
	},

	orderOffers(e, opts) {
		if (e != null) {
			e.preventDefault();
		}

		const $target = $(e.currentTarget);
		if ($target.hasClass('disabled')) {
			return this;
		}

		let routeInfos = _.map(this.offers, (o) => o.routeInfo);

		STATE.showLoader();
		this.disableElements(e);

		routeInfos.forEach((route) => {
			route.seatsRequest.fullCompartment = route.train._compartmentRequest;
		});

		routeInfos = routeInfos.map((info, i) => {
			return {routeInfo: info, comments: this.model.get(`comment${i}`)};
		});
		const emails = this.model.get('emails').toJSON();

		axios.post('/midoffice/ibecorp-b2b/rail/sendToApprove', {
			parameters: _.extend({
				routeInfos,
				emails,
				sendEmail: false,
			}, opts),
		}, this.model).then((result) => {
			STATE.hideLoader();
			if (!_.isEmpty(result.data.result.messages)) {
				const messages = result.data.result.messages;
				const popup = new Widgets.Popup({
					type: 'info',
					content: messages.length && _.map(messages, (m) => m.text).join('<br/>'),
					actions: [
						{
							label: L10N.get('common.close'),
							action: () => {
								STATE.navigate([STATE.ROUTES.CABINET_ORDER, result.data.result.newBooking.uid].join('/'));
								popup.hide();
							},
						},
					],
				});
				popup.show();
			} else {
				STATE.navigate([STATE.ROUTES.CABINET_ORDER, result.data.result.newBooking.uid].join('/'));
			}
			this.ticketModalOffers.hide();
		});
		return this;
	},

	copyToClipboard(e) {
		if (e) e.preventDefault();
		let result = '';
		const containers = this.$el.find('[data-copy-container]');
		_.each(containers, (el) => {
			result += `${GlUl.gatherTextToCopyToClipBoard(el)}\n\n`;
		});
		logger.debug(result);
		GlUl.copyToClipboard(result);
	},

});
